import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlidesTall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSlidesTall"><Path fillRule="evenodd" clipRule="evenodd" d="M6.75 2C5.23122 2 4 3.23122 4 4.75V15.25C4 16.7688 5.23122 18 6.75 18H8V19.25C8 20.7688 9.23122 22 10.75 22H17.25C18.7688 22 20 20.7688 20 19.25V8.75C20 7.23122 18.7688 6 17.25 6H16V4.75C16 3.23122 14.7688 2 13.25 2H6.75ZM10.75 6H14.5V4.75C14.5 4.05964 13.9404 3.5 13.25 3.5H6.75C6.05964 3.5 5.5 4.05964 5.5 4.75V15.25C5.5 15.9404 6.05964 16.5 6.75 16.5H8V8.75C8 7.23122 9.23122 6 10.75 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlidesTall;
